import { cn, Segmented } from '@gramas/ui'
import { useState } from 'react'
import { FastFood } from './FastFood.js'
import { FoodList } from './FoodList.js'
import { Recipes } from './Recipes.js'

type Section = 'products' | 'fastfood' | 'recipes'

/**
 * The three ways a food gets into the diary that are not a barcode scan:
 * a catalogued product, a batch you cooked, or something assembled at a counter.
 * Sections stay mounted so switching away and back keeps search text and
 * scroll position — same reasoning as the shell's tab panes.
 */
export function Foods() {
  const [section, setSection] = useState<Section>('products')

  return (
    <div className="flex h-full flex-col">
      <header data-tour="foods-sections" className="shrink-0 border-b border-line px-3 py-2">
        <Segmented
          label="Skiltis"
          value={section}
          onValueChange={setSection}
          className="w-full"
          // Greitas maistas sits next to Produktai because it is the same kind
          // of act — picking something somebody else made — and Receptai is the
          // odd one out: it is the only tab you go to to *build* something.
          options={[
            { value: 'products', label: 'Produktai' },
            { value: 'fastfood', label: 'Greitas maistas' },
            { value: 'recipes', label: 'Receptai' },
          ]}
        />
      </header>

      <div className="relative min-h-0 flex-1">
        <div className={cn('absolute inset-0', section !== 'products' && 'invisible')}>
          <FoodList />
        </div>
        <div className={cn('absolute inset-0', section !== 'recipes' && 'invisible')}>
          <Recipes />
        </div>
        <div className={cn('absolute inset-0', section !== 'fastfood' && 'invisible')}>
          <FastFood />
        </div>
      </div>
    </div>
  )
}
